export enum SubscriptionAuthorizations {
  IscrizioniAnprIns = 'ISCRIZIONI.NASCITA.INS',
  IscrizioneAire = 'ISCRIZIONI.AIRE.INS',
}

export const SubscriptionBirth = [SubscriptionAuthorizations.IscrizioniAnprIns];

export const SubscriptionAire = [SubscriptionAuthorizations.IscrizioneAire];

export const SubscriptionAuthorizationsList = [...SubscriptionBirth, ...SubscriptionAire];
